module.exports = __webpack_public_path__ + "media/categories/293-349007db.svg";